import { Component } from 'vue-property-decorator'

import Checkup from '@src/data/checkup'
import MemberAccount from '@src/routes/members/account'

@Component(
  {
    computed: {
      checkup () {
        return this.$store.state.checkup
      }
    }
  }
)
export class AccountDetails extends MemberAccount {

  private checkup: Checkup

  constructor () {
    super()
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  beforeDestroy () {
    let checkup = new Checkup(this.checkup)
    checkup.generalInfoAdded = true
    checkup.updateState()
    this.$store.dispatch('setCheckup', checkup)
  }
}
